<template>
  <div>
    <div class="utils__title mb-3">
      <strong class="text-uppercase font-size-16">{{
        $t("post.title")
      }}</strong>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <a-form :form="form" @submit="handleSubmit">
              <a-form-item
                label="User"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 12 }"
              >
                <!-- <a-input
				        v-decorator="['subject', { rules: [{ required: false, message: 'Please input your subject!' }] }]"
				      /> -->
                <a-select @change="handleChange" default-value="All User">
                  <a-select-option v-for="(i, index) in data" :key="index">
                    {{ i.user1.fullname || i.user1 }} -
                    {{ i.user2.fullname || i.user1 }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item
                class="w-100"
                :label="$t('post.subject')"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
              >
                <a-input
                  type="textarea"
                  v-model="content"
                  :placeholder="$t('post.subject')"
                ></a-input>
              </a-form-item>
              <a-form-item
                label=" "
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 12 }"
              >
                <a-button
                  icon="mail"
                  type="primary"
                  @click="sendMessenger"
                  :disabled="loading"
                >
                  Gửi
                </a-button>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/mixins/api";
import helper from "@/mixins/helper";

export default {
  components: {},
  data() {
    return {
      content: "",
      configs: {
        spellChecker: false,
      },
      form: this.$form.createForm(this, { name: "newpost" }),
      loading: false,
      data: "",
      value: -1,
    };
  },
  methods: {
    sendMessenger() {
      console.log(this.value, "this.data.length", this.data.length);

      if (this.value == this.data.length - 1 || this.value == -1) {
        console.log("Gui all");
        this.user = this.data;
      } else if (this.value != this.data.length - 1) {
        console.log("Gui", this.value);
        this.user = [this.data[this.value]];
      }
      if (this.content.trim() != "") {
        this.loading = true;
        this.api("admin/sendMessenger", {
          user: this.user,
          message: {
            createdAt: new Date().getTime() / 1000,
            system: true,
            text: this.content,
          },
        })
          .then((res) => {
            console.log(res);
            this.content = "";
            // this.coin = "";
          })
          .finally((e) => {
            this.loading = false;
            alert("Gửi tin nhắn thành công!");
            // location.href = "/admin_transaction";
          });
      } else alert("Bạn chưa nhập nội dung tin nhắn");
    },
    handleChange(value) {
      this.value = value;
      console.log(`selected ${value}`);
    },
    loadData() {
      this.data = this.$store.messenger;
      this.data.push({ user1: "All User", user2: "All User" });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true;
          this.api("news", {
            id: this.$route.params["id"],
            content: this.content,
            ...values,
          }).then((res) => {
            console.log(res);
            this.loading = false;
          });
        }
      });
    },
  },
  mounted() {
    // console.log('param',this.$store.messenger);
    this.loadData();
    // setTimeout(this.loadData, 100)
  },
  mixins: [api, helper],
};
</script>
<style>
@import "~simplemde/dist/simplemde.min.css";
</style>

